<script setup>
import CustomLink from '@/components/CustomLink.vue';
import HamburgerMenu from '@/components/menu/HamburgerMenu.vue';
import Sidebar from 'primevue/sidebar';
import { helpCenterURL } from '@/data/shared-faqs';
import { ref } from 'vue';
import { useRouter } from 'vue-router';
import MenuLinks from '@/components/MenuLinks.vue';
import LogoMenu from '@/components/menu/LogoMenu.vue';
import { useWayfinding } from '@/composables/wayfinding';

const router = useRouter();
const isMenuOpen = ref(false);
const emits = defineEmits(['close', 'click', 'toggleAccordion']);

const { mobileDisplayLinks } = useWayfinding();

function toggleMenu() {
  isMenuOpen.value = !isMenuOpen.value;
}

function handleLinkClick(args) {
  toggleMenu();
  emits('click', args);
}

function trackAccordionEvent(details) {
  emits('toggleAccordion', details);
}

function isDropdownOpen(links) {
  return links?.children
    ?.map((link) => link.route)
    .includes(router.currentRoute.value.name);
}
</script>

<template>
  <Sidebar
    v-model:visible="isMenuOpen"
    :class="$style['mobile-sidebar']"
    position="full"
  >
    <template #header>
      <div :class="$style['header']">
        <LogoMenu mobile @click="toggleMenu" />
      </div>
    </template>
    <div>
      <MenuLinks
        v-for="link in mobileDisplayLinks"
        :key="link.title()"
        :links="link"
        :class="$style['mobile-sidebar-menu-links']"
        :open-dropdown="isDropdownOpen(link) || link.forceDropdown"
        :force-dropdown="link.forceDropdown"
        ref-type="mobile-link"
        @linkClicked="handleLinkClick"
        @toggleAccordion="trackAccordionEvent"
      />
    </div>
    <div :class="$style['mobile-sidebar-bottom-links']">
      <CustomLink
        :url="helpCenterURL"
        target="_blank"
        :class="$style['help-center']"
        :text="$t('common.helpCenter')"
      />
    </div>
  </Sidebar>
  <HamburgerMenu
    :class="$style['mobile-menu-button']"
    data-ref="mobile-menu-button"
    @toggleMenu="toggleMenu"
  />
</template>

<style>
body .p-sidebar .p-sidebar-content {
  padding: 0;
}
</style>
<style lang="less" module>
.mobile-sidebar {
  [class='p-sidebar-content'] {
    height: 100vh;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
  [class='p-sidebar-header'] {
    justify-content: space-between;
  }
  .mobile-sidebar-menu-links {
    border-top: 1px solid #ceced0;
    &:last-child {
      border-bottom: 1px solid #ceced0;
    }
  }
  .mobile-sidebar-bottom-links {
    text-align: left;
    padding: 0 0 2.12rem 1.875rem;
  }
}
.mobile-sidebar-logo {
  display: none;
  width: 170px;
  @media only screen and (max-width: @wayfinding-tablet-width) {
    display: block;
  }
}
.mobile-menu-button {
  background: none;
  display: none;
  z-index: 2;
  @media only screen and (max-width: @wayfinding-tablet-width) {
    display: block;
    padding: 0 7px 4px;
  }
}
.help-center {
  display: inline-block;
  color: @cc-light-brown;
  text-decoration: underline;
}
</style>
